import { useOffice } from '@components/OfficeLoader';
import { useEffect, useState } from 'react';

const useFullScreen = (): [boolean, () => void, () => void, () => void] => {
  const [isFullScreen, setIsFullScreen] = useState(
    !!document?.fullscreenElement
  );
  const { isPowerpoint } = useOffice();

  const enterFullscreen = () => {
    if (document.fullscreenElement) return;
    const elem = document.documentElement;
    if (elem.requestFullscreen) elem.requestFullscreen();
    // @ts-expect-error webkitRequestFullscreen might not exist on document.
    else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
    // @ts-expect-error msRequestFullscreen might not exist on document.
    else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
  };
  const exitFullscreen = () => {
    if (!document.fullscreenElement) return;
    if (document.exitFullscreen) document.exitFullscreen();
    // @ts-expect-error webkitExitFullscreen might not exist on document.
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    // @ts-expect-error msExitFullscreen might not exist on document.
    else if (document.msExitFullscreen) document.msExitFullscreen();
  };

  const toggleFullScreen = () => {
    if (isPowerpoint) return;
    if (!document.fullscreenElement) enterFullscreen();
    else exitFullscreen();
  };

  const listener = () => {
    setIsFullScreen(!!document.fullscreenElement);
  };

  useEffect(() => {
    window.addEventListener('fullscreenchange', listener);
    return () => {
      window.removeEventListener('fullscreenchange', listener);
    };
  }, []);

  return [isFullScreen, toggleFullScreen, exitFullscreen, enterFullscreen];
};

export default useFullScreen;
